import { Loader2 } from 'lucide-react'
import type { CreateCheckoutSession } from '@/modules/auth/use-cases'
import type { EmitFunnelEvent } from '@/shared/domain'
import { Button } from '@/shared/ui/primitives'
import type { BillingCycle, OrgFormData, OrgType } from '../types'
import { useCheckoutStep } from './use-checkout-step'

export type CheckoutStepProps = {
  orgType: OrgType
  billingCycle: BillingCycle
  orgFormData: OrgFormData
  isMobile: boolean
  onCreateCheckoutSession: CreateCheckoutSession
  onEmitFunnelEvent: EmitFunnelEvent
  getAccessToken: () => Promise<string | null>
}

export function CheckoutStep(props: CheckoutStepProps) {
  const vm = useCheckoutStep(props)

  if (vm.error) {
    return (
      <div className="flex flex-col items-center gap-3 py-4" data-testid="checkout-error">
        <p role="alert" className="text-sm text-destructive">
          {vm.error}
        </p>
        <Button
          type="button"
          onClick={vm.retry}
          data-testid="checkout-retry"
        >
          Try again
        </Button>
      </div>
    )
  }

  return (
    <div
      className="flex flex-col items-center justify-center gap-3 py-8"
      data-testid="checkout-loading"
    >
      <Loader2 className="size-6 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Setting up payment…</p>
    </div>
  )
}
